import swiperFn     from './modules/swiper.js';

document.addEventListener("DOMContentLoaded", function(event) {
  swiperFn();
});